import React, { ReactElement } from 'react';
import styles from './styles.module.css';
import { BubbleIcon } from '../../theme/icons';

const Bubble = (): ReactElement => (
  <div className={styles.bubble}>
    <BubbleIcon />
  </div>
);

export default Bubble;
